let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("cM9em"), load("fr9NE"), load("h46oV")]).then(() => parcelRequire('3jTq3'));